/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";

const basePath = `${referenceService}/sumber-dana`;

/** get All Sumber Dana by Activated */
export const getSumberDana = async () => {
  const cached = getCache("sumber-dana");
  if (cached) return cached;

  const response = await api.get(`${basePath}`, {
    params: {
      activated: 1,
    },
  });
  const data = response?.data?.return;
  if (data) setCache("sumber-dana", data);
  return data;
};

/** Post Sumber Dana by Activated */
export const postSumberDana = async (params: any) => {
  const response = await api.post(`${basePath}`, params, {
    headers: { "Content-Type": "application/json" },
  });
  removeCacheByPrefix("sumber-dana");
  return response?.data?.return;
};

/** Delete Sumber Dana by Activated */
export const deleteSumberDana = async (params: any) => {
  const response = await api.delete(`${basePath}/${params}`);
  removeCacheByPrefix("sumber-dana");
  return response?.data?.return;
};
